import { render } from "./PhotoViewer.vue?vue&type=template&id=5716ff6c&scoped=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=js"
export * from "./PhotoViewer.vue?vue&type=script&lang=js"

import "./PhotoViewer.vue?vue&type=style&index=0&id=5716ff6c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5716ff6c"]])

export default __exports__